<form novalidate [formGroup]="primaryForm" (ngSubmit)="update()">
    <div class="row gx-3 mb-3">
        <div class="col-md-8">
            <label class="small mb-1" for="label">Nombre de la lista</label>
            <input type="text" class="form-control" formControlName="label">
        </div>
        <div class="col-md-4">
            <label class="small mb-1" for="observation">Observación</label>
            <input type="text" class="form-control" formControlName="observation">
        </div>
        <div class="col-md-12">
            <label class="small mb-1" for="email_notification">Correo de notificación</label>
            <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-envelope"></i></span>
                <input type="email" class="form-control" formControlName="email_notification"
                    placeholder="Opcional, ej: supervisor@empresa.cl">
            </div>
            <small class="text-muted">Si se indica, se notificará a este correo cuando alguna tarea de la lista se
                responda como negativa.</small>
        </div>
        <div class="col-md-12 mt-2">
            <label class="small mb-1">Tareas de la lista</label>
            <div class="d-flex align-items-center gap-2 mb-2" *ngFor="let item of items; let i = index">
                <input type="text" class="form-control" [(ngModel)]="item.label"
                    [ngModelOptions]="{standalone: true}" placeholder="Descripción de la tarea">
                <div class="form-check form-switch text-nowrap">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="item.evidence_required"
                        [ngModelOptions]="{standalone: true}" [id]="'edit-evidence-'+i">
                    <label class="form-check-label small" [for]="'edit-evidence-'+i">Evidencia</label>
                </div>
                <button type="button" class="btn text-danger" (click)="removeItem(i)"
                    [disabled]="items.length===1">
                    <i class="fa-solid fa-trash"></i>
                </button>
            </div>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addItem()">
                <i class="fa-solid fa-circle-plus me-1"></i> Agregar tarea
            </button>
        </div>
    </div>
    <button class="btn btn-primary w-100 mt-3" type="submit">GUARDAR CAMBIOS</button>
</form>
